import { memo, useCallback } from 'react';
import { getCurrencyCodeForPriceProperty } from 'customer-data-objects/lineItem/PropertyNames';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { parseNumericValue } from '../utils/parseNumericValue';
import isFractionalCurrencySupported from '../v2/utils/isFractionalCurrencySupported';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import { useProperty } from '../v2/hooks/useProperty';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { CurrencyInput } from 'foundations-components/transitional/components/CurrencyInput';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputPrice = props => {
  useComponentMountMetric('PropertyInputPrice');
  const {
    onChange,
    inputRef,
    currencyCode: passedCurrencyCode,
    min = 0
  } = props;
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const value = usePropertyValue();
  const handleChange = useCallback(evt => {
    const {
      target: {
        value: newValue
      }
    } = evt;
    if (typeof onChange === 'function') {
      // UICurrencyInput's onChange sends `number | null`; convert to `string | null`
      onChange(newValue == null ? evt : syntheticEvent(String(newValue)));
    }
  }, [onChange]);
  const currencyCode = passedCurrencyCode || getCurrencyCodeForPriceProperty(property.name) || '';
  const currencyValue = parseNumericValue(value);
  const defaultFractionalCurrencyProps = {
    maxFractionDigits: 6
  };
  const fractionalCurrencyProps = isFractionalCurrencySupported(objectTypeId) ? defaultFractionalCurrencyProps : undefined;
  return /*#__PURE__*/_jsx(CurrencyInput, Object.assign({}, getTransferrableProps(props), fractionalCurrencyProps, {
    min: min,
    currency: currencyCode,
    onChange: handleChange,
    inputRef: inputRef
    // @ts-expect-error UICurrencyInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: currencyValue
  }));
};
export default /*#__PURE__*/memo(PropertyInputPrice);